import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResolvedSectionLoader } from '../../models/loading.models';

@Component({
  selector: 'myt-app-section-loader-overlay',
  templateUrl: './app-section-loader-overlay.component.html',
  styleUrls: ['./app-section-loader-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppSectionLoaderOverlayComponent {
  @Input() sectionLoader: ResolvedSectionLoader | null = null;
}
